import { Component, Input, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'app/core/services/config.service';

@Component({
  selector: 'itpx-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent {

    private logo: string;
    
    constructor( private configService: ConfigService ) { 
        this.logo = this.configService.get('aws').downloadUrl + this.configService.get('images').dolphinLogo;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/not-found/not-found.component.ts